import React from "react";

import { QFormControl, QSelect } from "@qualio/ui-components";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ResultValueToLabel } from "../../../constants";

const ResultTable = { ...ResultValueToLabel, "Not Tested": "Not tested" };

export const TestResult: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Controller
      name="testResult"
      render={({ field: { onChange, value } }) => (
        <QFormControl label={t("filters.testResult")}>
          <QSelect
            value={value}
            onChange={(selectedItem) =>
              onChange(selectedItem ? selectedItem.value : null)
            }
            options={Object.entries(ResultTable).map(([value, label]) => ({
              value,
              label,
            }))}
          />
        </QFormControl>
      )}
    />
  );
};
